import styled, { css } from 'styled-components/macro';
import {
  h2,
  h6,
  h4,
  body16,
  body18,
  body14,
} from '../../../utils/css/typography';
import {
  headerHeight,
  footerHeight,
  inputBorderRadius,
} from '../../../utils/css/sizes';
import { mobile, tablet } from '../../../utils/css/media';
import { PageSubTitle } from '../../Admin/Hosts/AdminHostProfile/ProfileHeader/ProfileHeaderStyle';
import ButtonSmall from '../../common/ButtonSmall';
import {
  colorPink,
  colorYellow,
  colorGreen,
  colorOrange,
} from '../../../utils/css/colors';
import { bodyFont } from '../../../utils/css/fonts';

export const GuestSalonContainer = styled.div`
  height: calc(100vh - ${headerHeight}px - ${footerHeight}px - 100px);
  margin-inline-start: 138px;
  margin-inline-end: 138px;
  ${tablet(css`
    padding: 24px 4px 24px 10px;
    margin-inline-start: 40px;
    margin-inline-end: 40px;
  `)}
  ${mobile(css`
    padding: 24px 4px 24px 10px;
    margin-inline-start: 0;
    margin-inline-end: 0px;
    height: calc(100vh - ${headerHeight}px - ${footerHeight}px);
  `)}
`;
export const HeaderSide = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: end;
  margin-top: 30px;
  margin-bottom: 20px;
`;
export const HeaderGuestContainer = styled.div`
  display: flex;
  margin-top: 30px;
  margin-bottom: 20px;
  flex-direction: column;
  ${mobile(css`
  margin-inline-start: 20px;
  `)}
`;
export const GuestsButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 85%;
`;
export const PageNameTitle = styled.div`
  display: flex;
  justify-content: center;
  ${h2}
  margin-bottom: 30%;
  ${mobile(css`
    ${h6}
    margin-bottom: 0;
  `)}
`;
export const ContainerHeader = styled.div`
  ${mobile(css`
    display: flex;
    flex-direction: column-reverse;
  `)}
`;
export const GuestTitleSalon = styled.div`
font-size: 32px;
font-family: ${bodyFont};
`;
export const GuestTitle = styled(PageSubTitle as any)`
font-family: 'HeeboMedium';
 ${mobile(css`
    display: none;
  `)}
`;
export const SearchForSalonButton = styled(ButtonSmall)`
  :hover {
    background-color: ${colorOrange} !important;
  }
  height: 45px;
  ${mobile(css`
    margin: 18px auto;
  `)}
`;

export const GuestSalonDetailsContainer = styled.div`
`;

export const HeaderFlex = styled.div`
  display: flex;
  align-items: baseline;
  margin-bottom: 2%;
  ${mobile(css`
    padding: 0 11px;
  `)};
`;
export const SalonTitle = styled.div`
  ${h4};
  color: ${colorPink};
  ${mobile(css`
    ${h6}
  `)};
`;
export const SalonTitleStatus = styled.div<{ stickerColor: boolean }>`
  background-color: ${({ stickerColor }) =>
    stickerColor ? `${colorYellow}` : `${colorGreen}`};
  border-radius: ${inputBorderRadius}px;
  text-align: center;
  padding: 5px 19px;
  ${body16}
  margin-inline-start: 25px;
`;
export const NoSalonContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 80%;
`;
export const NoSalonInnerContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;
export const NoSalonTitle = styled.div`
  ${h4}
  font-size: 2.3rem;
  margin: 3rem 0 3rem 0;
  ${mobile(css`
    ${body18}
  `)};
`;
export const NoSalonImage = styled.img`
  align-self: center;
  width: 110px;
  height: 110px;
`;
export const NoSalonSubtitle = styled.div`
  ${body16};
  display: flex;
  align-items: center;
  text-align: center;
  ${mobile(css`
    ${body14}
  `)};
`;